(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7925],{

/***/ 6325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-ready-for-orgs",
      function () {
        return __webpack_require__(37338);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ covid_ready_for_orgs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1989);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/setLanguage.js
var setLanguage = __webpack_require__(28690);
;// CONCATENATED MODULE: ./src/components/v5/Flag.tsx



const Flag_button = "outline-0 border-none bg-transparent text-white hover:text-green-400 cursor-pointer";
const Flag = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df aic",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: ()=>{
                    (0,setLanguage/* default */.Z)("en", false);
                },
                className: Flag_button,
                children: "English"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ml2 mr2 text-white",
                children: "|"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: ()=>{
                    (0,setLanguage/* default */.Z)("es", false);
                },
                className: Flag_button,
                children: "Espa\xf1ol(Beta)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ml2 mr2 text-white",
                children: "|"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: ()=>{
                    (0,setLanguage/* default */.Z)("zh", false);
                },
                className: Flag_button,
                children: "中文(Beta)"
            })
        ]
    });
/* harmony default export */ var v5_Flag = (/*#__PURE__*/react.memo(Flag));

// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
// EXTERNAL MODULE: ./src/components/v5/CovidReadyForOrgs/Footer.module.scss
var Footer_module = __webpack_require__(66065);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scrollmagic/dist/index.es.js
var index_es = __webpack_require__(84690);
// EXTERNAL MODULE: ./src/components/v5/CovidReadyForOrgs/Header.module.scss
var Header_module = __webpack_require__(40856);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReadyForOrgs/Header.tsx








const Hdr = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: {
            pathname: _constants/* v5Pages.home */.Td.home
        },
        className: (Header_module_default()).l,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((Header_module_default()).l2, " cIcon-guard")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Header_module_default()).l3,
                children: "COVID"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Header_module_default()).l4,
                children: "Ready"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Header_module_default()).l5,
                children: "by Carbon Health"
            })
        ]
    });
const Inner = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const items = [
        {
            id: 1,
            title: i18n.t("Baseline Testing"),
            link: "#how",
            dotColor: palette.yellow
        },
        {
            id: 2,
            title: i18n.t("Monitoring & Reporting"),
            link: "#monitoring",
            dotColor: palette.mint
        },
        {
            id: 3,
            title: i18n.t("About Carbon Health"),
            link: "#about",
            dotColor: palette.purple
        }
    ];
    const [id, setId] = (0,react.useState)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Header_module_default()).wrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hdr, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "basic ".concat(id ? "hoveredParent" : "", " ").concat((Header_module_default()).r),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Header_module_default()).rInner,
                    children: items.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: a.link,
                            className: "".concat((Header_module_default()).r1, " ").concat(a.id === id ? "hoveredA" : ""),
                            style: {
                                "--dotColor": a.dotColor
                            },
                            // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'SetStateAction<null>'.
                            onMouseEnter: ()=>setId(a.id),
                            onMouseLeave: ()=>setId(null),
                            children: a.title
                        }, a.id))
                })
            })
        ]
    });
};
const CovidReadyHeader = (param)=>{
    let { isMobile  } = param;
    const [h, setH] = (0,react.useState)(1000);
    (0,react.useEffect)(()=>{
        const layout = document.getElementById("layout");
        // @ts-expect-error TS2531: Object is possibly 'null'.
        setH(layout.offsetHeight);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Header_module_default()).outerWrap,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Controller */.Q, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Scene */.x, {
                // reverse={false}
                triggerHook: 0,
                offset: 1,
                triggerElement: "#layout",
                duration: h,
                // duration={pageLoaded ? 800 : "100%"}
                indicators: _constants/* dev */.WI,
                classToggle: "stick",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {})
                })
            })
        })
    });
};
/* harmony default export */ var Header = (/*#__PURE__*/react.memo(CovidReadyHeader));

;// CONCATENATED MODULE: ./src/components/v5/CovidReadyForOrgs/Footer.tsx







const Footer = (param)=>{
    let { landingPageData , supportEmail  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { ctaLink  } = landingPageData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Footer_module_default()).wrap,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Footer_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).c1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hdr, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                "--color": "#fff",
                                "--hColor": "#ccc",
                                marginTop: "1rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_Flag, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).c2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).a,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                className: (Footer_module_default()).a1,
                                color: "#1C4F75",
                                bg: "#f9f9f9",
                                href: ctaLink,
                                children: i18n.t("Get Started")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_module_default()).a2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Footer_module_default()).a21,
                                        children: [
                                            i18n.t("Having trouble registering? Contact"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Footer_module_default()).a22,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(supportEmail),
                                            className: (Footer_module_default()).a23,
                                            children: supportEmail
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CovidReadyForOrgs_Footer = (Footer);

// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/v5/CovidReadyForOrgs/Hero.module.scss
var Hero_module = __webpack_require__(33466);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReadyForOrgs/Hero.tsx







const Hero = (param)=>{
    let { imgExt , landingPageData  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { name , ctaLink =_constants/* covidReadyUrl */.$D  } = landingPageData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* ImgWithBg */.Zx, {
        className: "".concat((Hero_module_default()).wrap, " df aic"),
        bgImage: "/covidReadyForOrgs/hero",
        style: {
            backgroundSize: "60%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Hero_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "cIcon-arrow-down ".concat((Hero_module_default()).arr),
                    href: "#how",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "visually-hidden",
                        children: i18n.t("Scroll Down")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Hero_module_default()).l,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (Hero_module_default()).l2,
                            children: i18n.t("{{name}} is offering COVID-19 workplace management through Carbon Health", {
                                name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Hero_module_default()).l3,
                            children: i18n.t("Our shared goal is to keep all employees safe, healthy, and prevent infection outbreaks in the workplace.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Hero_module_default()).l4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                    href: ctaLink,
                                    color: "#1C4F75",
                                    bg: "#F9F9F9",
                                    fontSize: "16px",
                                    children: i18n.t("Get started")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                    href: "#how",
                                    color: "#F9F9F9",
                                    bg: "#408FAD",
                                    fontSize: "16px",
                                    className: (Hero_module_default()).btn2,
                                    children: i18n.t("Learn more")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                    className: (Hero_module_default()).r2,
                    src: "/covidReady2/mon-phone2.".concat(imgExt),
                    width: "298"
                })
            ]
        })
    });
};
/* harmony default export */ var CovidReadyForOrgs_Hero = (Hero);

// EXTERNAL MODULE: ./src/components/v5/CovidReadyForOrgs/How.module.scss
var How_module = __webpack_require__(93714);
var How_module_default = /*#__PURE__*/__webpack_require__.n(How_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReadyForOrgs/How.tsx





const How = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (How_module_default()).wrap,
        id: "how",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (How_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (How_module_default()).rs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (How_module_default()).r,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (How_module_default()).h1,
                                    children: i18n.t("How it works")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((How_module_default()).icon, " cIcon-guard"),
                                    style: {
                                        "--c": "#56336E",
                                        "--bg": "#F7E4F5"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: i18n.t("To start, you'll create a Carbon account and complete a COVID-19 assessment. Carbon Health is a medical care provider, and the account you create will be used to secure your medical information and communicate with their clinical staff around your care.")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: (How_module_default()).h2,
                                    children: i18n.t("ASSESSMENT")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cIcon-icon-phone ".concat((How_module_default()).icon),
                                    style: {
                                        "--c": "#1C4F75",
                                        "--bg": "#9EEAEF"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (How_module_default()).c2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: i18n.t("The COVID-19 assessment is a series of questions based on guidance from CDC, WHO and other public health authorities, as well as Carbon Health's experience testing and evaluating thousands of patients during the COVID-19 pandemic. This assessment creates a baseline of all enrolled staff, including:")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "".concat((How_module_default()).list, " basic"),
                                        children: [
                                            i18n.t("Whether you've been exposed"),
                                            i18n.t("How likely you are to be exposed based on your daily activities"),
                                            i18n.t("Risk of serious illness if you're infected"),
                                            i18n.t("Who else (such as family) you might put at serious risk if you're infected.")
                                        ].map((r)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: (How_module_default()).li,
                                                children: r
                                            }, r))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt8",
                                        children: i18n.t("Based on your assessment, Carbon Health will recommend a course of action. Carbon Health's recommendations might include you getting tested because of your risk or symptoms, seeing a telehealth clinician, or doing nothing.")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: (How_module_default()).h2,
                                    children: i18n.t("testing")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((How_module_default()).icon, " cIcon-flu-screening"),
                                    style: {
                                        "--c": "#88690C",
                                        "--bg": "#F3D95A"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: i18n.t("Employees who need to be tested, based on their answers to the assessment, will be able to book a testing appointment with their Carbon Health account. Carbon Health will list ample testing options within the app.")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: (How_module_default()).h2,
                                    children: i18n.t("daily checklist")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((How_module_default()).r, " mt4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((How_module_default()).icon, " cIcon-pie-line-graph-desktop"),
                                    style: {
                                        "--c": "#C14111",
                                        "--bg": "#FCD1A1"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).c2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: i18n.t("If your company participates in the Daily Symptom Tracker, you will receive a daily notification every day to check your symptoms.")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (How_module_default()).box,
                        id: "about",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: (How_module_default()).boxH,
                                style: {
                                    color: "#24A06D"
                                },
                                children: i18n.t("employee privacy")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (How_module_default()).boxBody,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                                    children: [
                                        "Your symptoms and health history will ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (How_module_default()).bold,
                                            children: "NOT"
                                        }),
                                        " be shared with your employer. Your test results will be shared with your employer."
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (How_module_default()).s,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (How_module_default()).s1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (How_module_default()).s11,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: (How_module_default()).s111,
                                            children: i18n.t("About Carbon health")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (How_module_default()).s112,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (How_module_default()).s1121,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/static/img/_common/coloredLogo.svg",
                                                        alt: "Carbon Health",
                                                        className: (How_module_default()).s11211
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (How_module_default()).s1122,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (How_module_default()).bold,
                                                                children: "Carbon Health"
                                                            }),
                                                            " is a technology enabled healthcare provider that combines smart technology with inviting clinics and a robust virtual offering. Carbon specializes in primary care, mental health, and has been working tirelessly to make COVID-19 testing available to all."
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* ImgWithBg */.Zx, {
                                className: (How_module_default()).s2,
                                bgImage: "/covidReadyForOrgs/b1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* ImgWithBg */.Zx, {
                                className: (How_module_default()).s2,
                                bgImage: "/covidReadyForOrgs/b2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* ImgWithBg */.Zx, {
                                className: (How_module_default()).s2,
                                bgImage: "/covidReadyForOrgs/b3"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CovidReadyForOrgs_How = (How);

// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
;// CONCATENATED MODULE: ./src/pages/covid-ready-for-orgs.tsx












const supportEmails = {
    brookfield: "brookfield-support@carbonhealth.com",
    "mcmaster-carr": "mcmaster-carr-support@carbonhealth.com",
    boltthreads: "boltthreads-support@carbonhealth.com",
    bridgebio: "bridgebio-support@carbonhealth.com",
    "maze-therapeutics": "maze-support@carbonhealth.com",
    senti: "senti-support@carbonhealth.com",
    "carbon-health-technology": "carbonites-cr-support@carbonhealth.com",
    alto: "alto-support@carbonhealth.com"
};
const CovidReadyForOrgs = (param)=>{
    let { landingPageData , orgSlug  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { imgExt , pageLoaded , isMobile  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch(store/* actions.setConfig */.Nw.setConfig({
            pageLoaded: true
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        noIndex: true,
        pageTitle: i18n.t("Get your workforce Covid Ready | Coronavirus Testing for Businesses at Carbon Health"),
        pageDescription: i18n.t("Get your employees tested for Coronavirus and back to work with Covid Ready by Carbon Health. On-site testing, at-home testing, and workforce management; open for business safely. "),
        noHeader: true,
        noFooter: true,
        pageImage: "covid-ready",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                pageLoaded,
                isMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReadyForOrgs_Hero, {
                pageLoaded,
                imgExt,
                landingPageData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReadyForOrgs_How, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReadyForOrgs_Footer, {
                pageLoaded,
                imgExt,
                landingPageData,
                // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ brookfield: string; "mcmaster-carr": string; boltthreads: string; bridgebio: string; "maze-therapeutics": string; senti: string; "carbon-health-technology": string; alto: string; }'.
                supportEmail: supportEmails[orgSlug] || "carbonites-cr-support@carbonhealth.com"
            })
        ]
    });
};
CovidReadyForOrgs.getInitialProps = async (param)=>{
    let { query: { orgSlug  }  } = param;
    return {
        landingPageData: await api/* api.get */.hi.get("/hib/organizations/".concat(orgSlug, "/landingPageData")) || {
            name: "Your company",
            ctaLink: _constants/* covidReadyUrl */.$D
        },
        orgSlug
    };
};
/* harmony default export */ var covid_ready_for_orgs = (CovidReadyForOrgs);


/***/ }),

/***/ 66065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Footer_wrap__cnW1w","inner":"Footer_inner__qDAuE","c2":"Footer_c2__Dy_io","a2":"Footer_a2__Zacio","a23":"Footer_a23__QuYL2"};

/***/ }),

/***/ 40856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerWrap":"Header_outerWrap__kibRc","wrap":"Header_wrap__ucZfv","mobile":"Header_mobile__ZlKqT","l3":"Header_l3__lC0GJ","l4":"Header_l4__kmrEY","l5":"Header_l5__16tyw","r1":"Header_r1__t7fi7","l":"Header_l__FW_LC","l2":"Header_l2__ZUhPn","r":"Header_r__rM72w","rInner":"Header_rInner__cJ1yh","r2":"Header_r2___n0F0"};

/***/ }),

/***/ 33466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Hero_wrap__hIQyw","heroImg":"Hero_heroImg__aujev","inner":"Hero_inner__luj6b","l":"Hero_l__AeO_m","r2":"Hero_r2__0NviU","l1":"Hero_l1__zlwCI","l12":"Hero_l12__w5AhS","l2":"Hero_l2__AFybe","l3":"Hero_l3__lvis4","l4":"Hero_l4__xHpX_","arr":"Hero_arr__5FGds","btn2":"Hero_btn2__LAWxn"};

/***/ }),

/***/ 93714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"How_wrap__KcuIO","inner":"How_inner__MyauB","h2":"How_h2__RREQt","mt2":"How_mt2__6Wa6K","mt4":"How_mt4__6aFZR","mt8":"How_mt8__KnfUb","mt12":"How_mt12__3oxbQ","list":"How_list__Onxcl","box":"How_box__G3iHz","boxH":"How_boxH__SRz3n","boxBody":"How_boxBody__yBGqK","bold":"How_bold__AANCk","s":"How_s__GoTlm","s11":"How_s11__3n7Ip","s111":"How_s111__hsMuS","s112":"How_s112__1ywPe","s11211":"How_s11211__RIMNx","s1122":"How_s1122__ivpIv","rs":"How_rs__dpZGM","r":"How_r__Nq0qO","c2":"How_c2__mUdFj","icon":"How_icon__UJUWP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,4690,6282,2122,9774,2888,179], function() { return __webpack_exec__(6325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);